<template>
  <div id="footer">
    <div class="img">
      <img
        src="../../assets/images/footer_nav/left.png"
        alt=""
      >
      <img
        src="../../assets/images/footer_nav/center.webp"
        alt=""
      >
      <img
        src="../../assets/images/footer_nav/right.png"
        alt=""
      >
    </div>
    <router-link
      to="/"
      class="footer_item"
      :class="active == 0 ? 'active' : ''"
    >
      <div class="icon_wrap">
        <!-- <svg
          width="27"
          height="27"
          viewBox="0 0 23 22"
          fill=""
          class="svg_icon"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.0617 22C13.9854 21.9994 13.9099 21.9844 13.8397 21.9559C13.7694 21.9273 13.7057 21.8857 13.6522 21.8335C13.5987 21.7813 13.5564 21.7194 13.5277 21.6515C13.4991 21.5836 13.4846 21.5109 13.4852 21.4377V15.0014C13.4851 14.6341 13.3333 14.2819 13.0632 14.022C12.793 13.7621 12.4265 13.6157 12.0441 13.6149H10.9559C10.5735 13.6157 10.207 13.7621 9.93685 14.022C9.66669 14.2819 9.5149 14.6341 9.51477 15.0014V21.4372C9.51537 21.5105 9.50093 21.5831 9.47229 21.651C9.44364 21.719 9.40135 21.7808 9.34782 21.833C9.29429 21.8852 9.23058 21.9268 9.16032 21.9554C9.09006 21.9839 9.01462 21.9989 8.93833 21.9995H5.56802C4.87788 21.9955 4.21752 21.729 3.73159 21.2583C3.24567 20.7877 2.9738 20.1512 2.97555 19.4884V12.5265H1.44158C1.15496 12.5235 0.875632 12.4393 0.638537 12.2846C0.401442 12.1299 0.217098 11.9115 0.108557 11.6567C1.55529e-05 11.402 -0.0279056 11.1221 0.0282849 10.8521C0.0844755 10.5822 0.222284 10.3341 0.424477 10.139L10.4829 0.40717C10.6163 0.278143 10.7749 0.175739 10.9497 0.105858C11.1245 0.0359769 11.3119 0 11.5013 0C11.6906 0 11.878 0.0359769 12.0528 0.105858C12.2276 0.175739 12.3862 0.278143 12.5196 0.40717L12.8659 0.746513L22.5755 10.139C22.7778 10.3342 22.9156 10.5823 22.9717 10.8523C23.0279 11.1222 23 11.4022 22.8913 11.657C22.7827 11.9118 22.5983 12.1302 22.3612 12.2848C22.124 12.4395 21.8446 12.5236 21.5579 12.5265H20.0255V19.4884C20.0272 20.1515 19.7551 20.7883 19.2687 21.259C18.7823 21.7298 18.1215 21.9961 17.431 21.9995L14.0617 22ZM17.43 20.8753C17.8124 20.8746 18.1788 20.7282 18.449 20.4682C18.7191 20.2083 18.8709 19.8561 18.8711 19.4889V11.9642C18.8705 11.8909 18.8849 11.8183 18.9136 11.7503C18.9422 11.6824 18.9845 11.6206 19.038 11.5684C19.0915 11.5161 19.1553 11.4746 19.2255 11.446C19.2958 11.4174 19.3712 11.4024 19.4475 11.4019H21.5574C21.6151 11.4035 21.6719 11.3879 21.7199 11.3571C21.768 11.3264 21.8048 11.282 21.8254 11.2302C21.8473 11.1815 21.8531 11.1275 21.842 11.0754C21.8309 11.0234 21.8035 10.9759 21.7634 10.9394L11.7049 1.20608L11.6999 1.19978C11.6448 1.15038 11.572 1.12343 11.4967 1.1246C11.4213 1.12578 11.3494 1.15499 11.2961 1.20608L1.23563 10.9379C1.19553 10.9745 1.16807 11.022 1.15696 11.074C1.14586 11.126 1.15165 11.18 1.17355 11.2288C1.19416 11.2806 1.23103 11.3249 1.27906 11.3557C1.32708 11.3864 1.38388 11.402 1.44158 11.4004H3.55149C3.62778 11.401 3.70322 11.416 3.77348 11.4445C3.84374 11.4731 3.90745 11.5147 3.96098 11.5669C4.01451 11.6191 4.0568 11.681 4.08545 11.7489C4.11409 11.8168 4.12853 11.8895 4.12793 11.9627V19.4884C4.12806 19.8556 4.27985 20.2078 4.55001 20.4678C4.82017 20.7277 5.18664 20.8741 5.56903 20.8748H8.36138V15.0014C8.35963 14.3382 8.63178 13.7015 9.11814 13.2308C9.6045 12.76 10.2654 12.4937 10.9559 12.4903H12.0441C12.7346 12.4937 13.3955 12.76 13.8819 13.2308C14.3682 13.7015 14.6404 14.3382 14.6386 15.0014V20.8748L17.43 20.8753Z"
            class="twoToneFill"
            fill=""
          />
        </svg> -->
        <img
          v-if="active == 0"
          src="../../assets/images/footer_nav/nav01_h.png"
          alt=""
        >
        <img
          v-else
          src="../../assets/images/footer_nav/nav01.png"
          alt=""
        >
      </div>
      <p class="footer_info">
        Inicio
      </p>
    </router-link>
    <router-link
      to="/activity"
      class="footer_item"
      :class="active == 1 ? 'active' : ''"
    >
      <div class="icon_wrap">
        <!-- <svg
          width="27"
          height="27"
          viewBox="0 0 22 20"
          fill=""
          class="svg_icon"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="3.91821"
            width="21"
            height="5.17951"
            rx="1"
            class="rect_svg"
            stroke=""
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.57227 9.26929V18.5C1.57227 19.3284 2.24384 20 3.07227 20H18.9294C19.7578 20 20.4294 19.3284 20.4294 18.5V9.26929H19.4294V18.5C19.4294 18.7761 19.2056 19 18.9294 19H3.07227C2.79612 19 2.57227 18.7761 2.57227 18.5V9.26929H1.57227Z"
            class="twoToneFill"
            fill=""
          />
          <rect
            x="10.2656"
            y="4.49976"
            width="1"
            class="rect_svg"
            height="14.4189"
            fill=""
          />
          <path
            d="M4.01653 1.96473C3.96162 -1.30192 6.40639 0.150146 8.10109 1.70311C8.34467 1.92631 8.1811 2.31732 7.85072 2.31732H4.38264C4.18483 2.31732 4.01986 2.16252 4.01653 1.96473Z"
            class="twoToneFill"
            fill=""
          />
          <path
            d="M17.5987 1.96473C17.6536 -1.30192 15.2088 0.150146 13.5141 1.70311C13.2706 1.92631 13.4341 2.31732 13.7645 2.31732H17.2326C17.4304 2.31732 17.5954 2.16252 17.5987 1.96473Z"
            class="twoToneFill"
            fill=""
          />
        </svg> -->
        <img
          v-if="active == 1"
          src="../../assets/images/footer_nav/nav02_h.png"
          alt=""
        >
        <img
          v-else
          src="../../assets/images/footer_nav/nav02.png"
          alt=""
        >
      </div>
      <p class="footer_info">
        Promoção
      </p>
    </router-link>
    <router-link
      to="/agent"
      class="footer_item"
      :class="active == 2 ? 'active' : ''"
    >
      <!-- <div
        v-if="isLogin"
        class="icon_wrap"
      >
        <svg
          width="27"
          height="27"
          viewBox="0 0 22 23"
          fill=""
          class="svg_icon"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.5172 14.3334L21.9993 8.04771L15.5172 1.36914V5.29771C7.85644 5.49414 5.10644 13.1549 5.4993 15.3156C8.17073 11.2299 13.291 10.4703 15.5172 10.6013V14.3334Z"
            class="twoToneFill"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.7857 0.583496H3.92857C1.75888 0.583496 0 2.34238 0 4.51207V18.6549C0 20.8246 1.75888 22.5835 3.92857 22.5835H18.0714C20.2411 22.5835 22 20.8246 22 18.6549V14.7264H21V18.6549C21 20.2723 19.6888 21.5835 18.0714 21.5835H3.92857C2.31117 21.5835 1 20.2723 1 18.6549V4.51207C1 2.89466 2.31117 1.5835 3.92857 1.5835H11.7857V0.583496Z"
            class="twoToneFill"
          />
        </svg>
      </div>
      <div
        v-else
        class="icon_wrap"
      >
        <svg
          width="27"
          class="svg_icon"
          height="27"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.8262 21.2736V0.72639L21.5006 3.2775V18.7225L14.8262 21.2736Z"
            class="login_path"
            fill="none"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.5 1H5V1.5V9.11905H6V2H13.4707V1H5.5ZM5.5 21.0476H5V20.5476V12.9286H6V20.0476H13.4707V21.0476H5.5Z"
            fill="currentColor"
          />
          <rect
            y="9.77783"
            width="8.18605"
            height="1.95556"
            rx="0.977778"
            class="twoToneFill"
          />
          <path
            d="M7.16211 13.6889V7.82227L11.7668 10.7556L7.16211 13.6889Z"
            class="twoToneFill"
          />
        </svg>
      </div> -->
      <div class="icon_wrap">
        <img
          src="../../assets/images/footer_nav/nav04.png"
          alt=""
        >
      </div>
      <p
        v-if="!isLogin"
        class="footer_info"
      >
        login
      </p>
      <p
        v-else
        class="footer_info"
      >
        Agent
      </p>
    </router-link>
    <router-link
      v-if="isLogin"
      to=""
      class="footer_item"
      :class="active == 3 ? 'active' : ''"
    >
      <div
        class="icon_wrap"
        @click="toRech"
      >
        <div class="icon_wrap">
          <img
            src="../../assets/images/footer_nav/nav03.png"
            alt=""
          >
        </div>
      </div>
      <p class="footer_info">
        Depósito
      </p>
    </router-link>
    <router-link
      v-else
      to="/showRegistro"
      class="footer_item"
      :class="active == 3 ? 'active' : ''"
    >
      <div class="icon_wrap">
        <!-- <svg
          width="27"
          height="27"
          class="svg_icon"
          viewBox="0 0 23 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="17.7656"
            y="12.272"
            width="1.5"
            height="8.08923"
            rx="0.75"
            class="twoToneFill"
            fill="var(--cms-primary-color)"
          />
          <rect
            x="14.4707"
            y="17.0667"
            width="1.5"
            height="8.09"
            rx="0.75"
            transform="rotate(-90 14.4707 17.0667)"
            class="twoToneFill"
            fill="var(--cms-primary-color)"
          />
          <path
            d="M15.9071 5.59322C15.9071 8.40613 13.6268 10.6864 10.8139 10.6864C8.00102 10.6864 5.7207 8.40613 5.7207 5.59322C5.7207 2.78031 8.00102 0.5 10.8139 0.5C13.6268 0.5 15.9071 2.78031 15.9071 5.59322Z"
            class="twoToneStroke"
            stroke=""
            style="fill:none;"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.3672 10.4407C13.3209 10.4407 14.2422 10.5793 15.1121 10.8374L14.596 11.7311C13.885 11.5417 13.1379 11.4407 12.3672 11.4407H10.3208C5.17308 11.4407 1 15.6137 1 20.7615C1 20.8932 1.10678 21 1.2385 21H15.1166L15.8168 22H1.2385C0.554495 22 0 21.4455 0 20.7615C0 15.0615 4.62079 10.4407 10.3208 10.4407H12.3672Z"
            class="twoToneFill"
            fill="var(--cms-text-color-secondary)"
          />
        </svg> -->
        <div class="icon_wrap">
          <img
            src="../../assets/images/footer_nav/nav04.png"
            alt=""
          >
        </div>
      </div>
      <p class="footer_info">
        Registro
      </p>
    </router-link>
    <router-link
      to="/person"
      class="footer_item"
      :class="active == 4 ? 'active' : ''"
    >
      <div class="icon_wrap">
        <!-- <svg
          width="27"
          height="27"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.0927 6.48336C17.0927 9.22629 14.8218 11.4667 11.9995 11.4667C9.17717 11.4667 6.90625 9.22629 6.90625 6.48336C6.90625 3.74043 9.17717 1.5 11.9995 1.5C14.8218 1.5 17.0927 3.74043 17.0927 6.48336Z"
            class="twoToneStroke"
            fill="transparent"
          />
          <rect
            x="11.25"
            y="14.1602"
            width="1.5"
            height="5.88215"
            rx="0.75"
            class="twoToneFill"
            fill="#fff"
          />
          <path
            d="M1.5 21.0394C1.5 15.9012 5.66536 11.7358 10.8036 11.7358H13.1964C18.3346 11.7358 22.5 15.9012 22.5 21.0394C22.5 21.8462 21.846 22.5001 21.0393 22.5001H2.96072C2.15399 22.5001 1.5 21.8462 1.5 21.0394Z"
            class="twoToneStroke"
            stroke="transparent"
          />
        </svg> -->
        <img
          v-if="active == 4"
          src="../../assets/images/footer_nav/nav05_h.png"
          alt=""
        >
        <img
          v-else
          src="../../assets/images/footer_nav/nav05.png"
          alt=""
        >
      </div>
      <p class="footer_info">
        Perfil
      </p>
    </router-link>
    <!-- <router-link
      v-else
      to="/support"
      class="footer_item"
      :class="active == 4 ? 'active' : ''"
    >
      <div class="icon_wrap">
        <svg
          width="27"
          height="27"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="svg_icon"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.4802 8.47937V11.1667C18.4802 11.7382 18.4203 12.2957 18.3064 12.8333H19.3262C19.4273 12.2932 19.4802 11.7361 19.4802 11.1667V8.47937C19.4802 3.79634 15.6839 0 11.0009 0C6.31782 0 2.52148 3.79634 2.52148 8.47937V16.1667C2.52148 18.3758 4.31234 20.1667 6.52148 20.1667H9.1167V19.1667H6.52148C4.86463 19.1667 3.52148 17.8235 3.52148 16.1667V8.47937C3.52148 4.34862 6.87011 1 11.0009 1C15.1316 1 18.4802 4.34863 18.4802 8.47937Z"
            class="twoToneFill"
            fill="var(--cms-text-color-secondary)"
          />
          <rect
            x="8.17383"
            y="17.4167"
            width="6.59506"
            height="4.58333"
            rx="2.29167"
          />
          <rect
            x="3.02148"
            y="6.91675"
            width="3.71076"
            height="8.16667"
            rx="0.5"
            style="fill: none;stroke: #fff;"
          />
          <rect
            x="15.2695"
            y="6.91675"
            width="3.71076"
            height="8.16667"
            rx="0.5"
            style="fill: none;stroke: #fff;"
          />
          <path
            d="M19.0078 14.2816V10.4041C19.0085 10.3567 19.0198 10.31 19.041 10.2673C19.0621 10.2246 19.0926 10.187 19.1303 10.1569C19.168 10.1269 19.212 10.1052 19.2592 10.0934C19.3064 10.0817 19.3556 10.0801 19.4035 10.0888C19.8442 10.1626 20.2446 10.3836 20.5359 10.7137C20.8272 11.0438 20.9911 11.4624 20.9995 11.8973V12.7874C20.9911 13.2224 20.8272 13.6409 20.5359 13.971C20.2446 14.3011 19.8442 14.5221 19.4035 14.596C19.3827 14.5998 19.3616 14.6016 19.3404 14.6015C19.2531 14.6008 19.1694 14.567 19.1073 14.5073C19.0452 14.4475 19.0095 14.3666 19.0078 14.2816Z"
            class="twoToneStroke"
            stroke="var(--cms-text-color-secondary)"
          />
          <path
            d="M2.99219 14.2816V10.4041C2.9915 10.3567 2.98019 10.31 2.95903 10.2673C2.93787 10.2246 2.90738 10.187 2.86969 10.1569C2.832 10.1269 2.78802 10.1052 2.74083 10.0934C2.69364 10.0817 2.64438 10.0801 2.59648 10.0888C2.15582 10.1626 1.75541 10.3836 1.46412 10.7137C1.17283 11.0438 1.00888 11.4624 1.00048 11.8973V12.7874C1.00888 13.2224 1.17283 13.6409 1.46412 13.971C1.75541 14.3011 2.15582 14.5221 2.59648 14.596C2.6173 14.5998 2.63844 14.6016 2.65961 14.6015C2.74694 14.6008 2.83055 14.567 2.89266 14.5073C2.95477 14.4475 2.99047 14.3666 2.99219 14.2816Z"
            class="twoToneStroke"
            stroke="var(--cms-text-color-secondary)"
          />
        </svg>
      </div>
      <p class="footer_info">
        Perfil
      </p>
    </router-link> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 0,
      isShowFt: true,
      isLogin: false
    };
  },
  created() {
    // console.log(this.active)
    let token = localStorage.getItem("token");
    if (token) {
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }
    this.$bus.$on("send2ftnav", (idx) => {
      this.active = idx;
    });
  },
  methods: {
    // showLogin() {
    //   this.$parent.is_show_login = true;
    // }
    showRegistro() {
      this.$parent.is_show_login = false;
      this.$parent.is_show_register = true;
    },
    toRech() {
      this.$parent.isShowRecharge = true;
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/variables.less";

#footer {
  position: fixed;
  height: 1.7rem;
  bottom: 0;
  left: 50%;
  margin-left: calc(-50%);
  right: 0;
  display: flex;
  background: @nav-bg-color;
  z-index: 3;
  // width: calc(100%);
  width: 100%;
  max-width: @maxWidth;
  border-top: 1px solid @textcolor1;
  //background-image: url("../../assets/images/footer/bg.jpg");
  .img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: 100%;
    display: flex;
    z-index: -1;
    img {
      height: 100%;
      flex: 1;
    }
  }
}

.footer_item {
  display: flex;
  width: 25%;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 0.3rem 0;
}

.svg_icon path {
  fill: @svgColor;
}

.twoToneStroke {
  stroke: @svgColor;
}

.icon_stroke {
  fill: none !important;
  stroke: @svgColor !important;
}

.svg_icon rect,
.svg_icon circle {
  fill: @svgColor;
}

.i4 rect,
.i4 path {
  fill: transparent;
}

.white {
  fill: #fff !important;
}

.rect_svg {
  fill: none !important;
  stroke: @svgColor !important;
}

.icon_wrap {
  width: 100%;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;

  svg {
    // fill: #fff
  }
  img {
    width: 25px;
    height: 25px;
  }
}

.nav_01 {
  background-image: url(../../assets/images/index/nav01.png);
}

.nav_02 {
  background-image: url(../../assets/images/index/nav02.png);
}

.nav_03 {
  background-image: url(../../assets/images/index/nav03.png);
}

.nav_04 {
  background-image: url(../../assets/images/index/nav04.png);
}

.nav_05 {
  background-image: url(../../assets/images/index/nav05.png);
}

.ft_icon {
  font-size: 0.667rem;
  color: #8f6ae9;
}

.footer_info {
  color: @textcolor1;
  font-size: .3rem;
  margin-top: 0.1rem;
}

.login_path {
  stroke: #FFFFFF;
  fill: none !important;
}

.active .nav_01 {
  background-image: url(../../assets/images/index/nav01_h.png);
}

.active .nav_02 {
  background-image: url(../../assets/images/index/nav02_h.png);
}

.active .nav_03 {
  background-image: url(../../assets/images/index/nav03_h.png);
}

.active .nav_04 {
  background-image: url(../../assets/images/index/nav04_h.png);
}

.active .nav_05 {
  background-image: url(../../assets/images/index/nav05_h.png);
}

.active .ft_icon {
  font-size: 0.8rem;
  color: #c74cf9;
}

.active .footer_info {
  // color: @anttextcolor;
}

.fimg {
  width: 1.1rem;
  height: 1.1rem;
}
</style>